// extracted by mini-css-extract-plugin
module.exports = {"total":"Header_total__0AoR2"};